import axios from 'axios';

export const getCSRFToken = (): string | null => {
  const cookies = document.cookie.split(';');
  const csrfCookie = cookies.find((cookie) =>
    cookie.trim().startsWith('XSRF-TOKEN=')
  );
  return csrfCookie ? decodeURIComponent(csrfCookie.split('=')[1]) : null;
};

export const fetchCSRFToken = async (): Promise<string | null> => {
  const existingToken = getCSRFToken();
  if (existingToken) {
    return existingToken;
  }

  try {
    const domain =
      window.location.hostname === 'localhost' ? 'http://localhost:3000' : '';
    const response = await axios.get(`${domain}/api/csrf-token`);
    return response.data.csrfToken;
  } catch (error) {
    return null;
  }
};

/**
 * Refresh CSRF token regardless of whether one exists or not.
 * This is useful for ensuring a fresh token before important operations
 * or to prevent token expiration during active sessions.
 */
export const refreshCSRFToken = async (): Promise<string | null> => {
  try {
    const domain =
      window.location.hostname === 'localhost' ? 'http://localhost:3000' : '';
    const response = await axios.get(`${domain}/api/csrf-token`);
    return response.data.csrfToken;
  } catch (error) {
    console.error('Failed to refresh CSRF token:', error);
    return null;
  }
};

// Start a timer to refresh the token before it expires
export const startCSRFTokenRefresh = (intervalMinutes = 5): (() => void) => {
  // Refresh every 20 minutes by default (token expires after 24 hours)
  const intervalId = setInterval(async () => {
    await refreshCSRFToken();
  }, intervalMinutes * 60 * 1000);

  // Return a function that can be used to stop the refresh timer
  return () => clearInterval(intervalId);
};

export const ensureCSRFToken = async (): Promise<void> => {
  const existingToken = getCSRFToken();
  if (!existingToken) {
    setTimeout(() => {
      if (
        !window.location.pathname.match('^/login') &&
        !window.location.pathname.match('^/confirm') &&
        !window.location.pathname.match('^/video-call')
      ) {
        localStorage.setItem('redirectAfterLogin', window.location.pathname);
        window.location.pathname = '/login';
      }
    }, 500);
  }
};
